const DEFAULT_MINIMUM_WITHDRAWAL_AMOUNT = 5000;
const DEFAULT_WALLET_CURRENCY = 'USD';

function normalizeText(value) {
  return value === null || value === undefined ? '' : String(value).trim();
}

function normalizeAmount(value) {
  const amount = Number(value);

  return Number.isInteger(amount) && amount > 0
    ? amount
    : DEFAULT_MINIMUM_WITHDRAWAL_AMOUNT;
}

function normalizeResponseCurrency(value) {
  return normalizeText(value).toUpperCase() || DEFAULT_WALLET_CURRENCY;
}

function normalizePayloadCurrency(value) {
  return normalizeText(value).toUpperCase();
}

export function mapPartnerSettingsResponseToDto(payload) {
  return {
    minimumWithdrawalAmount: String(normalizeAmount(payload?.minimumWithdrawalAmount)),
    walletCurrency: normalizeResponseCurrency(payload?.walletCurrency),
    walletCurrencyLocked: Boolean(payload?.walletCurrencyLocked),
  };
}

export function buildPartnerSettingsPayloadFromForm(form) {
  return {
    minimumWithdrawalAmount: Number(normalizeText(form?.minimumWithdrawalAmount)),
    walletCurrency: normalizePayloadCurrency(form?.walletCurrency),
  };
}

export function validatePartnerSettingsPayload(payload) {
  const errors = {};
  const amount = Number(payload?.minimumWithdrawalAmount);
  const walletCurrency = normalizeText(payload?.walletCurrency);

  if (!Number.isInteger(amount) || amount <= 0) {
    errors.minimumWithdrawalAmount = 'Enter a positive amount in minor units.';
  }

  if (!/^[A-Z]{3}$/.test(walletCurrency)) {
    errors.walletCurrency = 'Enter a 3-letter uppercase currency code.';
  }

  return errors;
}

export function mapPartnerSettingsFieldErrors(requestError) {
  const errors = {};
  const details = Array.isArray(requestError?.errors) ? requestError.errors : [];

  details.forEach((item) => {
    const parameter = normalizeText(item?.parameter);
    if (['minimumWithdrawalAmount', 'walletCurrency'].includes(parameter)) {
      errors[parameter] = normalizeText(item?.message) || 'Invalid value';
    }
  });

  return errors;
}
